export const STORE_KINDERGARTEN_ROLE = 'STORE_KINDERGARTEN_ROLE';
export const ADD_KINDERGARTEN_ROLE = 'ADD_KINDERGARTEN_ROLE';
export const SET_KINDERGARTEN_ROLES = 'SET_KINDERGARTEN_ROLES';
export const GET_KINDERGARTEN_ROLES = 'GET_KINDERGARTEN_ROLES';
export const UPDATE_KINDERGARTEN_ROLE = 'UPDATE_KINDERGARTEN_ROLE';
export const UPDATE_TYPE_DEFAULT_ROLE = 'UPDATE_TYPE_DEFAULT_ROLE';